import { functions } from "@/lib/firebase";
import { SearchResponseItem } from "@/lib/SemanticScholarApi";
import { httpsCallable } from "firebase/functions";

type GetPapersByIdRequest = {
  papers_id: Array<number>;
};

type GetPapersByIdResponse = {
  status: boolean;
  papers: Array<SearchResponseItem>;
};

/**
 * Get Papers with a list of ids
 * @param papers_id - The list of ids to get papers for
 */
const getPapersById = httpsCallable<
  GetPapersByIdRequest,
  GetPapersByIdResponse
>(functions, "get_papers_by_id");

export { getPapersById };
